export default __webpack_public_path__ + "static/media/tbnail02.png";